import {
	DetailedHTMLProps,
	DetailsHTMLAttributes,
	ReactElement,
	ReactInstance,
	Ref,
	RefObject,
} from 'react';
import {findDOMNode} from 'react-dom';
import {tryCall} from './try-call';

export function forkRef<T extends ReactElement<{ ref?: R }>, R>(originalChildren: T, forwardRef: RefObject<R>): (ref: R) => void {
	const originalProps = originalChildren.props;
	return (ref: R) => {
		if (originalProps && 'ref' in originalProps) {
			setRef(originalProps.ref, forwardRef);
		}
		setRef(ref, forwardRef);
	};
}

export function setRef<T>(ref: T, target: Ref<T>): void {
	if (target) {
		if (typeof target === 'function') {
			tryCall(target, ref);
			return;
		}

		if (typeof target === 'object') {
			(target as any).current = ref;
		}
	}
}

export type DetailedProps<T> = Omit<DetailedHTMLProps<DetailsHTMLAttributes<T>, T>, 'ref'>;

export function getDOMNode(componentInstance: ReactInstance): SVGElement | HTMLElement | null {
	try {
		const ref = findDOMNode(componentInstance);
		if (ref instanceof HTMLElement || ref instanceof SVGElement) {
			return ref;
		} else {
			return null;
		}
	} catch (e) {
		console.error(e);
	}
}
